import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class BookVersionViewService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  /** GET /BookVersionView/idBookVersion/{idBookVersion}/view */
  public RegisterView(idBookVersion: number): Observable<ReturnStruct> {
    const url = environment.urlApiPlatform + 'BookVersionView/idBookVersion/' + idBookVersion + '/view';
    return this.http
      .get<ReturnStruct>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** GET /BookVersionView/idKit/{idKit}/buy */
  public RegisterBuyClick(idKit: number): Observable<ReturnStruct> {
    const url = environment.urlApiPlatform + 'BookVersionView/idKit/' + idKit + '/buy';
    return this.http
      .get<ReturnStruct>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** GET /BookVersionView/idKit/{idKit}/cart */
  public RegisterAddToCart(idKit: number): Observable<ReturnStruct> {
    const url = environment.urlApiPlatform + 'BookVersionView/idKit/' + idKit + '/cart';
    return this.http
      .get<ReturnStruct>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
